// extracted by mini-css-extract-plugin
export default {"DropdownBox":"DropdownBox_DropdownBox__4zjQ-","DropdownBoxWrapper":"DropdownBox_DropdownBoxWrapper__Kb8ZH"};